import gql from "graphql-tag";

export const MY_TIME_GET_DASHBOARD_LIST = gql`
  query dashboardList(
    $page: Int
    $pageSize: Int
    $roleFilters: RoleFilterInput
    $sortField: String
    $sortDirection: String
    $searchField: String
    $searchText: String
    $role: String
  ) {
    dashboardList(
      page: $page
      pageSize: $pageSize
      roleFilters: $roleFilters
      sortField: $sortField
      sortDirection: $sortDirection
      searchField: $searchField
      searchText: $searchText
      role: $role
    ) {
      _id
      contractCode
      pipedName
      orgUnit
      jobClass
      acknowledgedAt
      approvedAt
      authorizedAt
      lastModificationDate
      employee
      recordingPeriod
    }
  }
`;
